import { useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import AlertModal from 'components/common/AlertModal';
import ErrorDataSummaryPatternModal from 'components/common/ErrorDataSummaryPatternModal/ErrorDataSummaryPatternModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import StatusHeader from 'components/common/StatusHeader';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { CheckedImportDataResponse } from 'features/Store/models';
import _ from 'lodash';
import { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import {
  FEATURE_IMPORT_DATA_ID,
  STATUS_ERROR,
  STATUS_SUCCESS,
  VALID_CSV_FILENAME,
  displayError,
  handleServiceError,
} from 'utils';
import ChangeRegistrationPatternNameModal from '../components/ChangeRegistrationPatternNameModal';
import importDataService from '../importDataService';

function ImportDataPage() {
  const { t } = useTranslation();
  // selector
  const isEditMode = useAppSelector(selectIsEditMode);
  //ref
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { showGlobalModal } = useGlobalModal();
  //state
  const [showChangeRegistrationPatternNameModal, setShowChangeRegistrationPatternNameModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<FileList | null>(null);
  // const [showErrorDataDetailModal, setShowErrorDataDetailModal] = useState<boolean>(false);
  // const [importCounterPatternId, setImportCounterPatternId] = useState<number>();
  const [showErrorSummaryModal, setShowErrorSummaryModal] = useState<boolean>(false);
  const [errorSummaryData, setErrorSummaryData] = useState<CheckedImportDataResponse>();

  const handleOpenMenuBookDetailModal = () => {
    setShowChangeRegistrationPatternNameModal(true);
  };

  const handleFileUploadAction = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = () => {
    if (fileInputRef.current) {
      let isValid = true;
      if (fileInputRef.current.files) {
        _.forEach(fileInputRef.current.files, (file) => {
          const index = _.findIndex(VALID_CSV_FILENAME, (file_name: string) => file_name === file.name.toUpperCase());
          if (index === -1 && isValid) {
            showGlobalModal(() => (
              <AlertModal message={t('ImportDataPage.Message.invalid_file_name')} title={t('App.error')} />
            ));
            isValid = false;
          }
        });
      }
      if (isValid) {
        setUploadedFiles(fileInputRef.current.files);
      }
    }
  };

  function showImportDataSummary(res: any) {
    // let isShowButtonErrorDetail = false;
    let errorSummary: CheckedImportDataResponse | null = null;
    if (res.data.error_data) {
      errorSummary = res.data.error_data as CheckedImportDataResponse;
      // isShowButtonErrorDetail =
      //   errorSummary.total_unregister <= MAXINUM_TOTAL_POS_UNREGISTER ||
      //   errorSummary.total_invalid_pos_code > 0 ||
      //   errorSummary.total_menu_has_poscode_in_main_and_sub_menu > 0 ||
      //   errorSummary.total_multiple_registered > 0 ||
      //   errorSummary.total_poscode_used_in_multiple_menu_subtitle_menu > 0;
    }

    if (errorSummary === null) {
      showGlobalModal(() => <AlertModal message={res.message} title={t('App.info')} size="lg" />);
      return;
    }

    // show ErrorSummaryModal
    setShowErrorSummaryModal(true);
    setErrorSummaryData(errorSummary);
  }

  function handleCloseErrorDataSummaryPatternModal() {
    setShowErrorSummaryModal(false);
    setErrorSummaryData(undefined);
  }

  // function handleOpenErrorDataDetailModal(errorSummary: CheckedImportDataResponse | null) {
  //   if (errorSummary) {
  //     setImportCounterPatternId(errorSummary.counter_pattern_id);
  //     setShowErrorDataDetailModal(true);
  //   }
  // }

  // function handleCloseErrorDataDetailModal() {
  //   setImportCounterPatternId(undefined);
  //   setShowErrorDataDetailModal(false);
  // }

  const handleImportClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    (async () => {
      try {
        if (uploadedFiles && uploadedFiles.length > 0) {
          const res = await importDataService.importData(uploadedFiles);
          if (res.status === STATUS_SUCCESS) {
            showImportDataSummary(res);
          } else if (res.status === STATUS_ERROR) {
            showGlobalModal(() => <AlertModal message={res.message} title={t('App.error')} />);
          }
        }
      } catch (e: any) {
        if (!handleServiceError(showGlobalModal, e as AxiosError)) {
          displayError(showGlobalModal, e as AxiosError);
        }
      } finally {
        if (fileInputRef.current) fileInputRef.current.value = '';
      }
    })();
  };

  let info = t('ImportDataPage.Message.file_not_select');
  if (uploadedFiles && uploadedFiles.length > 0) {
    info = '';
    _.forEach(uploadedFiles, (file) => {
      info += file.name + ',';
    });
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="page-header">
          <StatusHeader />
        </div>
        <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
          <div className="page-content store-setting-page d-flex flex-column">
            <div>
              <FeatureTitleBar title={t('ImportDataPage.head_title')} />
            </div>
            <div className="text-end mb-3">
              <Button className="btn-primary ms-3" onClick={handleOpenMenuBookDetailModal}>
                {t('ImportDataPage.Button.change_registration_pattern_name')}
              </Button>
            </div>
            <div>
              {t('ImportDataPage.description_1')}
              <br />
              <br />
              {t('ImportDataPage.description_2')}
              <br />
              {t('ImportDataPage.description_3')}
              <br />
              {t('ImportDataPage.description_4')}
              <br />
              {t('ImportDataPage.description_5')}
              <br />
              {t('ImportDataPage.description_6')}
              <br />
              {t('ImportDataPage.description_7')}
              <br />
              <br />
              {t('ImportDataPage.description_8')}
            </div>
            <div className="mt-3">
              <Button className="btn-lg me-2" onClick={handleFileUploadAction}>
                {t('ImportDataPage.Button.selected_files')}
              </Button>
              <input type="file" hidden ref={fileInputRef} onChange={handleFileChange} accept=".csv" multiple />
              {info}
            </div>
            <div className="mt-3">
              <Button className="btn--dark-green btn-lg" onClick={handleImportClick}>
                {t('ImportDataPage.Button.file_upload')}
              </Button>
            </div>
            {showChangeRegistrationPatternNameModal && (
              <ChangeRegistrationPatternNameModal onClose={() => setShowChangeRegistrationPatternNameModal(false)} />
            )}
          </div>
        </div>
      </div>

      {showErrorSummaryModal &&
        errorSummaryData &&
        createPortal(
          <ErrorDataSummaryPatternModal
            errorFromFeatureId={FEATURE_IMPORT_DATA_ID}
            data={errorSummaryData}
            onClose={handleCloseErrorDataSummaryPatternModal}
          />,
          document.body
        )}

      {/* {showErrorDataDetailModal &&
        importCounterPatternId &&
        createPortal(
          <ErrorDataDetailModal
            errorFromFeatureId={FEATURE_IMPORT_DATA_ID}
            counterPatternId={importCounterPatternId}
            onClose={handleCloseErrorDataDetailModal}
          />,
          document.body
        )} */}
    </>
  );
}

export default ImportDataPage;
